import { BRAIN, BrainView } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useNavigate } from 'react-router-dom';

/** AI Brain › General — simplified (amendment 32 §2). No brain-settings API — stage's mock. */
export function SettingsBrainPage() {
  const location = useWorkspaceLabel();
  const navigate = useNavigate();
  return (
    <BrainView
      data={BRAIN}
      location={location}
      onSeeTextsOff={() => { void navigate('/patients?contact=texts-off'); }}
    />
  );
}
